module.exports = __webpack_public_path__ + "img/Lu_Fang@2x.73a73eb1.png";